import { render } from "./News25.vue?vue&type=template&id=2b3e8f9c"
import script from "./News25.vue?vue&type=script&lang=js"
export * from "./News25.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__